import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import { MdChevronLeft, MdChevronRight } from 'react-icons/md'
import { PropTypes } from 'prop-types'
const Banner = ({ images }) => {
  return (
    <div className='flex relative justify-center items-center  h-[screen] bg-white'>
      <Carousel
        showThumbs={false}
        showStatus={false}
        infiniteLoop={true}
        onClickItem={
            (index, item) => {
                if(item?.props?.href) {
                    window.open(item.props.href, '_blank', 'noopener,noreferrer');
                }
            }
        }
        renderArrowNext={(onClickHandler, hasNext, label) => {
          return (
            <button
              type='button'
              onClick={onClickHandler}
              title={label}
              className='absolute right-0 top-1/2 z-10 text-red-500  flex items-center justify-center'
            >
              <MdChevronRight size={50} />
            </button>
          )
        }}
        renderArrowPrev={(onClickHandler, hasNext, label) => {
          return (
            <button
              type='button'
              onClick={onClickHandler}
              title={label}
              className='absolute left-0 top-1/2 z-10 text-red-500  flex items-center justify-center'
            >
              <MdChevronLeft size={50} />
            </button>
          )
        }}
        renderIndicator={(onClickHandler, isSelected, index, label) => {
          return (
            <li
              className={`${
                isSelected ? 'bg-red-500' : 'bg-gray-800'
              } w-2 h-2 rounded-full m-1 cursor-pointer`}
              onClick={e => {
                e.preventDefault()
                onClickHandler()
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  onClickHandler()
                }
              }}
              role='button'
              tabIndex={0}
            />
          )
        }}
      >
        {images?.map((img, index) => {
          return (
            <a
              href={img?.link}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Banner Image'
              className='w-full h-full'
              key={index}
            >
              <img
                className='max-w-full h-auto object-cover'
                src={img?.image}
              />
            </a>
          )
        })}
      </Carousel>
    </div>
  )
}
Banner.propTypes = {
  images: PropTypes.array
}
export default Banner
